import { Button } from "@itandi/itandi-bb-ui";
import { useRouter } from "next/router";
import { useCallback } from "react";
import { Dropdown } from "~/components/common/parts/dropdown/Dropdown";
import { Table } from "~/components/common/parts/table/Table";
import { TableBody } from "~/components/common/parts/table/TableBody";
import { TableHeader } from "~/components/common/parts/table/TableHeader";
import { TableRow } from "~/components/common/parts/table/TableRow";
import { SubtypeListRow } from "~/components/specifics/settings/subtypes/SubtypeListRow";
import { useSubtypes } from "~/hooks/useSubtypes";
import type { Subtype } from "~/models/Subtype";
import { PATH as REPAIR_PATH } from "~/pages/settings/subtypes/repair/todo_templates";
import { PATH as RESTORATION_PATH } from "~/pages/settings/subtypes/restoration/todo_templates";
import Styles from "./SubtypeList.module.scss";

export function SubtypeList() {
	const router = useRouter();
	const { data: subtypes } = useSubtypes().useIndex();
	const renderSubtype = useCallback(
		(subtype: Subtype) => <SubtypeListRow key={subtype.id} subtype={subtype} />,
		[]
	);

	if (subtypes === null) {
		return null;
	}

	return (
		<div>
			<Table>
				<TableHeader>
					<th>タイプ名</th>
					<th>取込キー</th>
					<th>TODOテンプレート</th>
					<th className={Styles.ButtonCol}>操作</th>
				</TableHeader>
				<TableBody>
					<TableRow>
						<td>原状回復</td>
						<td>restoration</td>
						<td>
							<Button
								height="small"
								onClick={() => {
									router.push(RESTORATION_PATH);
								}}
							>
								設定
							</Button>
						</td>
						<td>
							<Dropdown disabled title="操作" variant="normal" />
						</td>
					</TableRow>
					<TableRow>
						<td>修繕</td>
						<td>repair</td>
						<td>
							<Button
								height="small"
								onClick={() => {
									router.push(REPAIR_PATH);
								}}
							>
								設定
							</Button>
						</td>
						<td>
							<Dropdown disabled title="操作" variant="normal" />
						</td>
					</TableRow>
					{subtypes.map(renderSubtype)}
				</TableBody>
			</Table>
		</div>
	);
}
